import { api } from '../helpers';

export const getContent = (url) => api(`/Content/${url}`, 'GET', null, null);

export const getContactUs = (_, token) =>
	api('/Content/GetContactUs', 'GET', null, null, token);
